export default __webpack_public_path__ + "static/galatasaray-logo-18c55e19a9732e193d5907570cff77a7.png";